/* ============================================================
   STINCHFIELD ARMY THEME — JS
   Variant image swap works on BOTH product pages and cards.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastEl = document.createElement('div');
  toastEl.className = 'sf-toast';
  toastEl.setAttribute('role', 'status');
  document.body.appendChild(toastEl);
  var toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('sf-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('sf-show'); }, 2400);
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-sf-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    }).catch(function(){});
  }

  function addToCart(variantId, qty, btn) {
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { toast('Added to cart'); refreshCartCount(); })
      .catch(function () { toast('Could not add \u2014 try the product page'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }

  /* ---------- Variant picker ---------- */
  function wireVariantPicker(root) {
    var dataEl = root.querySelector('[data-sf-variants]');
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var selects = root.querySelectorAll('[data-sf-option]');
    function current() {
      if (!selects.length) return variants[0];
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }
    return { current: current, selects: selects, variants: variants };
  }

  /* Swap an <img> (handles <picture> + srcset) */
  function swapImage(img, url) {
    if (!img || !url) return;
    var pic = img.closest('picture');
    if (pic) { pic.querySelectorAll('source').forEach(function (s) { s.remove(); }); }
    img.removeAttribute('srcset');
    img.src = url;
  }

  /* ---------- Cards (quick-add + variant image swap) ---------- */
  document.querySelectorAll('[data-sf-product]').forEach(function (card) {
    var addBtn = card.querySelector('[data-sf-add]');
    var picker = wireVariantPicker(card);
    if (!picker) return;
    var cardImg = card.querySelector('[data-sf-main-img]');
    var cardPrice = card.querySelector('[data-sf-price]');

    function sync() {
      var v = picker.current();
      if (addBtn) {
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        else if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        else { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      }
      if (v && cardImg && v.image) swapImage(cardImg, v.image);
      if (v && cardPrice && v.price_formatted) cardPrice.textContent = v.price_formatted;
    }
    picker.selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();

    if (addBtn) addBtn.addEventListener('click', function () {
      var v = picker.current();
      if (v && v.available) addToCart(v.id, 1, addBtn);
    });
  });

  /* ---------- Product page ---------- */
  var pp = document.querySelector('[data-sf-main-product]');
  if (pp) {
    var picker = wireVariantPicker(pp);
    var priceEl = pp.querySelector('[data-sf-price]');
    var compareEl = pp.querySelector('[data-sf-compare]');
    var buyBtn = pp.querySelector('[data-sf-buy]');
    var qtyInput = pp.querySelector('[data-sf-qty]');
    var idInput = pp.querySelector('[data-sf-id]');
    var mainImg = pp.querySelector('[data-sf-main-img]');

    function syncProduct() {
      if (!picker) return;
      var v = picker.current();
      if (!v) { if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
      if (compareEl) {
        if (v.compare_formatted) { compareEl.textContent = v.compare_formatted; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      if (buyBtn) {
        if (v.available) { buyBtn.disabled = false; buyBtn.textContent = 'Add to cart'; }
        else { buyBtn.disabled = true; buyBtn.textContent = 'Sold out'; }
      }
      if (mainImg && v.image) swapImage(mainImg, v.image);
    }
    if (picker) { picker.selects.forEach(function (s) { s.addEventListener('change', syncProduct); }); syncProduct(); }

    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var v = picker ? picker.current() : null;
      if (!v || !v.available) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(v.id, qty, buyBtn);
    });

    pp.querySelectorAll('[data-sf-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        swapImage(mainImg, t.dataset.sfThumb);
        pp.querySelectorAll('[data-sf-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', b === t); });
      });
    });
  }

  /* ---------- Carousel arrows ---------- */
  document.querySelectorAll('[data-sf-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-sf-track]');
    if (!track) return;
    var per = parseInt(root.getAttribute('data-per'), 10) || 3;
    track.style.setProperty('--n', per);
    var prev = root.querySelector('[data-sf-prev]');
    var next = root.querySelector('[data-sf-next]');
    function step() {
      var card = track.querySelector('.sf-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return (card.getBoundingClientRect().width + gap) * per;
    }
    function upd() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', upd); window.addEventListener('resize', upd); upd();
  });

  refreshCartCount();
})();
